import create from 'zustand';
import messageActions from './message-actions';
import roomActions from './room-action';
import {
  IChatStore,
  IChatAction,
  IRoomAction,
} from './types';

const initialState: IChatStore = {
  conversation: {
    messages: {},
    localMessages: {},
    selected: {
      messageIds: [],
      messageAlign: [],
    },
    isLoading: false,
    isLoadingPrevMessage: false,
    isLoadingNextMessage: false,
  },
  rooms: {
    default: {
      list: [],
      totalInvited: 0,
      unreadRequest: 0,
      isLoading: false,
      isLoadingMore: false,
      pagination: {
        is_last_page: false,
      },
    },
    invited: {
      list: [],
      isLoading: false,
      isLoadingMore: false,
      pagination: {
        is_last_page: false,
      },
    },
  },
  reply: {
    to_id: 0,
    visible: false,
  },
};

const useChatStore = create<IChatStore & IChatAction & IRoomAction>((...arg) => ({
  ...initialState,
  ...messageActions(...arg),
  ...roomActions(...arg),
}));

export default useChatStore;
